import ReactRailsUJS from "@shared/polyfill/react_ujs";
import { clientInitCoralogix } from "@shared/utils/clientInitCoralogix/clientInitCoralogix.client";
import { clientInitDatadogRum } from "@shared/utils/clientInitDatadogRum/clientInitDatadogRum.client";
import { initFsAnalytics } from "@shared/utils/initFsAnalytics/initFsAnalytics";
import { initSentry } from "@shared/utils/initSentry/initSentry";
import "@unauthenticated/oauth/fontawesome";
import "@styles/entry-points/oauth.scss";

initFsAnalytics("unauth");

const componentRequireContext = require.context("@unauthenticated/oauth", false);

initSentry({
  enableRouterInstrumentation: true,
  tracesSampleRate: 0.01,
});
clientInitCoralogix({
  sessionConfig: {
    sessionSampleRate: 0,
    alwaysTrackSessionsWithErrors: false,
  },
});
clientInitDatadogRum();

ReactRailsUJS.useContext(componentRequireContext);
